import React from "react";

export default function NotesField({ value, setValue }) {
  return (
    <div className="mt-3 pt-3 border-t border-gray-300 dark:border-gray-600">
      <label className="block text-xs font-semibold text-gray-600 dark:text-gray-300 mb-2">
        📝 Notes
      </label>
      <textarea
        value={value?.notes ?? ""}
        onChange={(e) =>
          setValue({
            ...(value || {}),
            notes: e.target.value,
          })
        }
        placeholder="Add any notes..."
        className="w-full border-2 border-orange-500 rounded-lg p-3 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-100 text-sm resize-none h-20 focus:outline-none focus:ring-2 focus:ring-orange-400"
      />
    </div>
  );
}
